export default __webpack_public_path__ + "static/media/star-glyph-16px-grey.e7bef2b0.svg";